import { useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';

import {
  getBrowserPanelState,
  subscribeToBrowserPanel,
} from '../browser-panel-registry';

/**
 * "Browser" for a lone session, "Browser 2" once there are several; shared by
 * the chat card and its rail row so they match.
 */
export function useBrowserSessionLabel(sessionId: string): string {
  const { t } = useTranslation('browser-automation');
  const sessionIds = useSyncExternalStore(
    subscribeToBrowserPanel,
    () => getBrowserPanelState().sessionIds,
  );
  const index = sessionIds.indexOf(sessionId);
  if (sessionIds.length < 2 || index < 0) {
    return t('browserAutomation.liveView.title');
  }
  return t('browserAutomation.liveView.numbered', { number: index + 1 });
}
